import React from "react";
import { useEffect, useState } from "react";

const FaqRadio = (props) => {
  const selectItem = [
    { id: 1, value: "운행문의" },
    { id: 2, value: "정산문의" },
    { id: 3, value: "앱 사용자 불편 신고" },
    { id: 4, value: "기타" },
    { id: 5, value: "가입문의" },
    { id: 6, value: "등록문의" },
    { id: 7, value: "네트워크 오류" },
    { id: 8, value: "네비게이션 오류" },
  ];
  const [values, setValues] = useState();
  const selectHandler = (e) => {
    setValues(e.target.value);
  };
  useEffect(() => {
    props.onSelect(values);
  }, [values]);

  return (
    <>
      {selectItem.map((item) => {
        return (
          <div className="aos_select" key={item.id}>
            <label htmlFor={`faqType${item.id}`} onClick={selectHandler}>
              <input type="radio" id={`faqType${item.id}`} value={item.value} />
              {item.value}
            </label>
          </div>
        );
      })}
    </>
  );
};
export default FaqRadio;
